import React from 'react'
import GetRequest from '../Services/APIRequest'
import Loading from '../Components/Loading'
import Error from '../Components/Error'


const OutstandingInvoices = (props) => {


    const distID = localStorage.getItem('distributorId');
    const boostID = localStorage.getItem('companyIdBooster');
    const parisID = localStorage.getItem('companyIdParis'); 
  
    const { data, error, isLoaded } = GetRequest(`/Account/GetAllOutstandingInvoices/${distID}/${boostID}`);
      
    if (error !== null) {
        return <Error data=" " />;
    }
    if (!isLoaded) {
        return <Loading />;
    }
    console.log(data)

    return (
        <>
            <h5  className='invHead' >Outstanding Invoices</h5>
            <div id="accordion1">
                {
                    data.result && data.result.map((item, index) => (
                        <div className="card  ">
                            <div className="card-header hdcolacc text-white">
                                <a className="btn" data-bs-toggle="collapse" href={`#collapse${item.id}`}>
                                    {item.titleOrNumber}
                                </a>
                            </div>
                            <div id={`collapse${item.id}`} className="collapse" data-bs-parent="#accordion1">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-sm-6'>  
                                           Invoice# :  {item.titleOrNumber}  <br /> Order# {item.orderNumber}   <br /> 
                                            Amount# : {item.amount}<br />
                                            {item.createdOnDateInStringFormat} 
                                        </div>
                                        <div className='col-sm-2'>  <input type='text' className='form-control' id={item.id} name='' onBlur={props.funcname} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }

            </div>


        </>
    )

}

export default OutstandingInvoices